/* Team and careers pages: chat buttons open the site chat in place (photo intent where marked), and consent-gated GA4
   clicks on the page's CTAs. Without the chat script, chat buttons go to /pages/contact-us. Everything else works without this file. */
(() => {
  'use strict';
  if (window.wnfswPeopleInitialized) return;
  window.wnfswPeopleInitialized = true;
  const measurementId = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, { send_to: measurementId, page_location: window.location.origin + window.location.pathname, ...params });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  // Capture phase, so this runs before Motion's link handler starts its page transition. The page root is looked up at
  // click time because the theme can re-render the main content after this script runs.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const root = target && target.closest('[data-wnfsw-people-page]');
    if (!root) return;
    const page = root.getAttribute('data-wnfsw-people-page') === 'careers' ? 'careers' : 'team';
    const cta = target.closest('[data-wnfsw-cta]');
    if (cta) track(`wnf_${page}_cta_click`, { cta_placement: cta.getAttribute('data-wnfsw-cta'), transport_type: 'beacon' });
    const chat = target.closest('[data-wnfsw-chat]');
    if (chat) {
      event.preventDefault();
      const intent = chat.getAttribute('data-wnfsw-chat');
      if (typeof window.WNFChatOpen === 'function') {
        window.WNFChatOpen(intent === 'photo' ? { intent: 'photo' } : undefined);
        track(`wnf_${page}_chat_open`, { intent: intent || 'general' });
      } else {
        window.location.href = '/pages/contact-us';
      }
    }
  }, true);
})();
